module.exports = __webpack_public_path__ + "static/media/stones-g768e8e248_640.36e40d10.jpg";